import request from '../request'

export default {
  getProveedores () {
    return request.get('proveedor')
  }
}
